(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('glucose-intervention', {
                parent: 'entity',
                url: '/glucose-intervention',
                data: {
                    authorities: [],
                    pageTitle: 'GlucoseInterventions'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/glucose-intervention/list/glucose-interventions.html',
                        controller: 'GlucoseInterventionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_GLUCOSE_INTERVENTION];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_GLUCOSE_INTERVENTION, access);
                }]
            });
    }
})();
